type AnimateProps = {
  width: number;
};

export default {
  base: {
    enter: {
      y: 0,
      opacity: 1,
    },

    initial: {
      y: 16,
      opacity: 0,
    },
  },

  background: {
    enter: ({ width }: AnimateProps) => ({
      width: `${width}px`,
      opacity: 1,
    }),

    initial: {
      width: 0,
      opacity: 0,
    },
  },
};
